import { z } from "zod/v4";
import { customFieldSchema, customFieldValueSchema } from "../schemas/custom-field";
import { fetchApi, fetchVoid } from "./internal";

type CreateCustomFieldInput = {
	field_key: string;
	label: string;
	field_type: "text" | "number" | "date" | "boolean" | "single_select" | "multi_select";
	options?: unknown;
	required?: boolean;
	position?: number;
};

type UpdateCustomFieldInput = {
	label?: string;
	options?: unknown;
	required?: boolean;
	position?: number;
};

export const customFields = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/fields`, z.array(customFieldSchema)),
	create: (clubId: string, data: CreateCustomFieldInput) =>
		fetchApi(`/clubs/${clubId}/fields`, customFieldSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, fieldId: string, data: UpdateCustomFieldInput) =>
		fetchApi(`/clubs/${clubId}/fields/${fieldId}`, customFieldSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, fieldId: string) =>
		fetchVoid(`/clubs/${clubId}/fields/${fieldId}`, {
			method: "DELETE",
		}),
};

export const customValues = {
	list: (clubId: string, userId: string) =>
		fetchApi(`/clubs/${clubId}/members/${userId}/values`, z.array(customFieldValueSchema)),
	set: (clubId: string, userId: string, fieldId: string, value: unknown) =>
		fetchApi(`/clubs/${clubId}/members/${userId}/values/${fieldId}`, customFieldValueSchema, {
			method: "PUT",
			body: JSON.stringify({ value }),
		}),
	delete: (clubId: string, userId: string, fieldId: string) =>
		fetchVoid(`/clubs/${clubId}/members/${userId}/values/${fieldId}`, {
			method: "DELETE",
		}),
};
